// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@rails/ujs"
import "@fortawesome/fontawesome-free/js/all.min.js";
import "./controllers"
import "tom-select/dist/css/tom-select.css"

// Disabilita l’auto-discover di Dropzone (eviti conflitti)
Turbo.session.drive = false

import * as ActiveStorage from "@rails/activestorage"
import Rails from "@rails/ujs"
Rails.start()
ActiveStorage.start()

// document.addEventListener("turbo:submit-end", () => {
//   const overlay = document.querySelector(".spinner-overlay")
//   if (overlay) overlay.classList.add("hidden")
// })

import "trix"
import "@rails/actiontext"
